import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { Outlet } from 'react-router-dom';

import { Announcement } from '@/components/Announcement';
import { Footer } from '@/components/Footer';
import { ScrollToPagePosition } from '@/components/ScrollToPagePosition';
import { TopNavBar } from '@/components/TopNavBar';
import { AuthProvider } from '@/components/providers/AuthProvider';
import { ErrorToast } from '@/components/ui/ErrorToast';
import { ErrorContextProvider } from '@/context/ErrorContext';

export const MainLayout = () => {
    return (
        <AuthProvider>
            <ScrollToPagePosition />
            <ErrorContextProvider>
                <Stack
                    sx={{
                        backgroundColor: '#d0d5dd10',
                        minHeight: '100vh',
                    }}
                >
                    <ErrorToast />
                    <TopNavBar />
                    <Announcement />
                    <Box sx={{ flexGrow: 1 }}>
                        <Outlet />
                    </Box>
                    <Footer />
                </Stack>
            </ErrorContextProvider>
        </AuthProvider>
    );
};
